<template>
  <main id="blog-page" class="nuxt-page">
    <!-- Background -->
    <div class="page-bg">
      <div class="page-gradient-1"></div>
      <div class="page-gradient-2"></div>
      <div class="page-grid"></div>
    </div>

    <section class="blog-section">
      <div class="blog-container">
        <!-- Header -->
        <div class="page-header">
          <span class="page-badge">
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <path d="M2 3h6a4 4 0 0 1 4 4v14a3 3 0 0 0-3-3H2z"/>
              <path d="M22 3h-6a4 4 0 0 0-4 4v14a3 3 0 0 1 3-3h7z"/>
            </svg>
            Blog & Artikel
          </span>
          <h1 class="page-title">Kenapa Harus Memilih <span class="text-gradient">Yohom?</span></h1>
          <p class="page-subtitle">Temukan alasan mengapa ribuan pengguna mempercayakan kebutuhan mereka kepada Yohom.</p>
        </div>

        <!-- FAQ-style Cards -->
        <div class="faq-list">
          <div
            v-for="(item, index) in articles"
            :key="index"
            class="faq-card"
            :class="{ 'faq-card--active': activeIndex === index }"
            @click="toggleItem(index)"
          >
            <div class="faq-header">
              <div class="faq-number">{{ String(index + 1).padStart(2, '0') }}</div>
              <h3 class="faq-title">{{ item.title }}</h3>
              <div class="faq-chevron">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <polyline points="6 9 12 15 18 9"/>
                </svg>
              </div>
            </div>
            <transition name="slide">
              <div class="faq-body" v-if="activeIndex === index">
                <p>{{ item.content }}</p>
              </div>
            </transition>
          </div>
        </div>

        <!-- CTA -->
        <div class="blog-cta">
          <div class="cta-card">
            <div class="cta-content">
              <h3 class="cta-title">Tertarik bergabung?</h3>
              <p class="cta-desc">Daftar sekarang sebagai mitra Yohom dan nikmati berbagai keuntungan.</p>
            </div>
            <router-link to="/gabungmitra" class="cta-btn">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <line x1="5" y1="12" x2="19" y2="12"/>
                <polyline points="12 5 19 12 12 19"/>
              </svg>
              Gabung Mitra
            </router-link>
          </div>
        </div>
      </div>
    </section>
  </main>
</template>

<script>
export default {
  name: "Blog",
  data() {
    return {
      activeIndex: 0,
      articles: [
        {
          title: "Solusi Permasalahan Anda",
          content: "Hal pertama yang teringat jika ditanya tentang Yohom tentunya adalah Solusi. Yohom merupakan aplikasi yang akan membantu permasalahan keseharian Anda seperti kerusakan AC, Atap, Saluran Air dan lainnya.",
        },
        {
          title: "Mudah & Praktis Digunakan",
          content: "Aplikasi Yohom merupakan aplikasi yang berbasis pada Smartphone dimana pengguna sudah sangat familiar. Jadi, penggunaan Yohom sangat Mudah dan Praktis.",
        },
        {
          title: "Pelayanan yang Ramah dan Bergaransi",
          content: "Kami sangat menjamin bahwa pelayanan pada Yohom sangatlah baik. Selain itu Yohom juga memberikan Garansi pada permasalahan yang Anda hadapi.",
        },
      ],
    };
  },
  methods: {
    toggleItem(index) {
      this.activeIndex = this.activeIndex === index ? null : index;
    },
  },
};
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Public+Sans:wght@400;500;600;700;800&display=swap');

.nuxt-page {
  font-family: 'Public Sans', sans-serif;
  min-height: 100vh;
  background: #fcfcfd;
  position: relative;
  overflow: hidden;
  padding: 100px 16px 60px;
  -webkit-font-smoothing: antialiased;
}

/* Background */
.page-bg {
  position: absolute;
  inset: 0;
  pointer-events: none;
}

.page-gradient-1 {
  position: absolute;
  top: -150px;
  right: -80px;
  width: 500px;
  height: 500px;
  border-radius: 50%;
  background: radial-gradient(circle, rgba(59, 130, 246, 0.08) 0%, transparent 70%);
  animation: bgFloat 8s ease-in-out infinite;
}

.page-gradient-2 {
  position: absolute;
  bottom: -100px;
  left: -60px;
  width: 400px;
  height: 400px;
  border-radius: 50%;
  background: radial-gradient(circle, rgba(16, 185, 129, 0.06) 0%, transparent 70%);
  animation: bgFloat 10s ease-in-out infinite reverse;
}

.page-grid {
  position: absolute;
  inset: 0;
  background-image:
    linear-gradient(rgba(0, 0, 0, 0.02) 1px, transparent 1px),
    linear-gradient(90deg, rgba(0, 0, 0, 0.02) 1px, transparent 1px);
  background-size: 64px 64px;
  mask-image: radial-gradient(ellipse 80% 50% at 50% 30%, black 20%, transparent 100%);
  -webkit-mask-image: radial-gradient(ellipse 80% 50% at 50% 30%, black 20%, transparent 100%);
}

@keyframes bgFloat {
  0%, 100% { transform: translateY(0) scale(1); }
  50% { transform: translateY(-20px) scale(1.03); }
}

/* Container */
.blog-section {
  position: relative;
  z-index: 1;
}

.blog-container {
  max-width: 720px;
  margin: 0 auto;
}

/* Header */
.page-header {
  text-align: center;
  margin-bottom: 48px;
}

.page-badge {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 6px 14px;
  border-radius: 100px;
  background: rgba(59, 130, 246, 0.08);
  color: #2563eb;
  font-size: 13px;
  font-weight: 600;
  letter-spacing: 0.02em;
  border: 1px solid rgba(59, 130, 246, 0.15);
  margin-bottom: 20px;
}

.page-title {
  font-size: 36px;
  font-weight: 800;
  color: #111827;
  line-height: 1.2;
  letter-spacing: -0.025em;
  margin: 0 0 12px;
}

.text-gradient {
  background: linear-gradient(135deg, #10b981 0%, #059669 50%, #047857 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.page-subtitle {
  font-size: 16px;
  color: #6b7280;
  line-height: 1.6;
  max-width: 480px;
  margin: 0 auto;
}

/* FAQ Cards */
.faq-list {
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-bottom: 48px;
}

.faq-card {
  background: #ffffff;
  border: 1px solid #e5e7eb;
  border-radius: 14px;
  overflow: hidden;
  cursor: pointer;
  transition: all 0.2s ease;
}

.faq-card:hover {
  border-color: #d1d5db;
}

.faq-card--active {
  border-color: rgba(16, 185, 129, 0.3);
  box-shadow: 0 4px 12px rgba(16, 185, 129, 0.06);
}

.faq-header {
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 18px 24px;
}

.faq-number {
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 40px;
  height: 40px;
  border-radius: 10px;
  background: rgba(16, 185, 129, 0.08);
  color: #059669;
  font-size: 14px;
  font-weight: 700;
  flex-shrink: 0;
}

.faq-card--active .faq-number {
  background: linear-gradient(135deg, #10b981, #059669);
  color: #fff;
}

.faq-title {
  flex: 1;
  font-size: 16px;
  font-weight: 600;
  color: #374151;
  margin: 0;
}

.faq-card--active .faq-title {
  color: #111827;
}

.faq-chevron {
  color: #9ca3af;
  transition: transform 0.2s ease;
  flex-shrink: 0;
}

.faq-card--active .faq-chevron {
  transform: rotate(180deg);
  color: #059669;
}

.faq-body {
  padding: 0 24px 20px 80px;
}

.faq-body p {
  font-size: 15px;
  color: #6b7280;
  line-height: 1.7;
  margin: 0;
}

/* Slide transition */
.slide-enter-active,
.slide-leave-active {
  transition: all 0.2s ease;
}

.slide-enter-from,
.slide-leave-to {
  opacity: 0;
  transform: translateY(-8px);
}

/* CTA */
.blog-cta {
  margin-top: 24px;
}

.cta-card {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 28px 32px;
  background: linear-gradient(135deg, #111827 0%, #1f2937 100%);
  border-radius: 16px;
  gap: 24px;
}

.cta-title {
  font-size: 18px;
  font-weight: 700;
  color: #f9fafb;
  margin: 0 0 4px;
}

.cta-desc {
  font-size: 14px;
  color: #9ca3af;
  margin: 0;
}

.cta-btn {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 11px 22px;
  background: linear-gradient(135deg, #10b981, #059669);
  color: #fff;
  font-size: 14px;
  font-weight: 600;
  font-family: 'Public Sans', sans-serif;
  text-decoration: none;
  border-radius: 10px;
  white-space: nowrap;
  transition: all 0.2s ease;
  box-shadow: 0 2px 8px rgba(16, 185, 129, 0.3);
}

.cta-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 16px rgba(16, 185, 129, 0.4);
}

/* Responsive */
@media (max-width: 640px) {
  .nuxt-page {
    padding: 80px 16px 40px;
  }

  .page-title {
    font-size: 28px;
  }

  .faq-header {
    padding: 14px 18px;
  }

  .faq-body {
    padding-left: 18px;
  }

  .cta-card {
    flex-direction: column;
    text-align: center;
    padding: 24px;
  }

  .cta-btn {
    width: 100%;
    justify-content: center;
  }
}
</style>